export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-cpu-line',
      title: '高性能，超可靠',
      description: '基于ARM架构优化，性能提升高达10倍',
      highlights: [
        '64位ARM架构处理器，性能卓越',
        '内置AI加速器，机器学习性能优异',
        '低延迟网络，毫秒级响应'
      ],
      gradient: 'from-blue-500 to-cyan-500',
      imageIcon: 'ri-cpu-line'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全可靠，开箱即用',
      description: '企业级安全防护，全方位数据保护',
      highlights: [
        '多层安全防护体系，数据加密传输',
        '合规认证齐全，满足行业标准',
        '7×24小时安全监控，实时威胁检测'
      ],
      gradient: 'from-emerald-500 to-teal-500',
      imageIcon: 'ri-shield-check-line'
    },
    {
      icon: 'ri-line-chart-line',
      title: '弹性扩展，智能运维',
      description: '智能弹性扩展，按需付费更经济',
      highlights: [
        '自动弹性伸缩，秒级扩容',
        '智能监控运维，故障自愈',
        '按需付费模式，成本可控'
      ],
      gradient: 'from-violet-500 to-purple-500',
      imageIcon: 'ri-line-chart-line'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">核心优势</h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            基于ARM架构的云计算优势，为您提供更高性能、更安全可靠的云服务体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-300">
              {/* Feature Image */}
              <div className={`h-40 sm:h-48 bg-gradient-to-br ${feature.gradient} flex items-center justify-center`}>
                <i className={`${feature.imageIcon} text-6xl sm:text-7xl text-white/90`}></i>
              </div>
              
              <div className="p-5 sm:p-6 lg:p-8">
                {/* Icon and Title */}
                <div className="flex items-center mb-3 sm:mb-4">
                  <div className="w-10 h-10 sm:w-12 bg-blue-100 rounded-lg flex items-center justify-center mr-3 sm:mr-4">
                    <i className={`${feature.icon} text-xl sm:text-2xl text-blue-600`}></i>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900">{feature.title}</h3>
                </div>
                
                <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">{feature.description}</p>
                
                {/* Highlights */}
                <ul className="space-y-2 sm:space-y-3">
                  {feature.highlights.map((highlight, idx) => (
                    <li key={idx} className="flex items-start">
                      <i className="ri-check-line text-green-500 mt-0.5 sm:mt-1 mr-2 sm:mr-3 flex-shrink-0"></i>
                      <span className="text-sm text-gray-700">{highlight}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
